<button #button shareButton="facebook" #facebookBtn="shareButton" [url]="this.url">
  <fa [style.color]="facebookBtn?.color" class="share-icon" name="facebook-square"></fa>
</button>
<button #button shareButton="twitter" #twitterBtn="shareButton" [url]="this.url">
  <fa [style.color]="twitterBtn?.color" class="share-icon" name="twitter-square"></fa>
</button>
<button #button shareButton="linkedin" #linkedinBtn="shareButton" [url]="this.url">
  <fa [style.color]="linkedinBtn?.color" class="share-icon" name="linkedin-square"></fa>
</button>
<button #button shareButton="copy" #copyBtn="shareButton" [url]="this.url" (click)="showCopyAlert()">
  <fa [style.color]="copyBtn?.color" size="sm" class="share-icon" name="link"></fa>
</button>
